import { useState } from "react"
export const RealProperty = () => {

    const [loader, setLoader] = useState(true)
    // for inquires
    const [inquiries, setInquiries] = useState({
        inquiriesList: [],
        inquiriesLoader: false,
        inquiriesModal: false,
        inquiriesWebId: null,
        inquiresInftScroll: true,
        inquiresIsLoading: false,
        inquiriesCooldown: false,
        inquiriesHasMore: true,
        inquiriesLastId: 0,
    })
    // for agent application
    const [agents, setAgents] = useState({
        agentsList: [],
        agentsLoader: false,
        agentsModal: false,
        agentsInftScroll: true,
        agentsIsLoading: false,
        agentsCooldown: false,
        agentsHasMore: true,
        agentsLastId: 0,
    })
    // for requested listing
    const [rqstdLstng, setRqstdLstng] = useState({
        list: [],
        loader: true,
        rqstdLstngInftScroll: true,
        rqstdLstngIsLoading: false,
        rqstdLstngCooldown: false,
        rqstdLstngHasMore: true,
        rqstdLstngLastId: 0,
    })
    const [types, setTypes] = useState({
        propertyTypes: [],
        propertySubTypes: [],
        allPropertySubTypes: [],
        indoorFacilities: [],
        outdoorFacilities: [],
        checkListItems: [],
    })
    // for api locations
    const [dataLocations, setDataLocations] = useState({
        provinces: [],
        cities: [],
        barangays: [],
    });
    // for modal confirmation
    const [confirmation, setConfirmation] = useState({
        isIndoorFacOpen: false,
        indoorLoader: false,
        isOutdoorFacOpen: false,
        outdoorLoader: false,
        publishConfirmation: false,
        hasInvalidInputs: false,
        loader: false,
        statusConfirmation: false,
        statusLoader: false,
        listUpdatingLoader: false,
        isListUpdated: false,
        soldConfirmation: false,
        soldUpdatingLoader: false,
        isSoldUpdated: false,
    });

    const [status, setStatus] = useState({
        statusId: "",
        statusData: "",
        isStatusUpdated: false,
    })

    const [mainInfrmtn, setMainInfrmtn] = useState({
        listingTitle: { value: "", stat: false, msg: "Listing title is required" },
        description: "",
        ownerType: { value: 1, stat: false, msg: "Owner type is required" },
        offerType: { value: 1, stat: false, msg: "Offer type is required" },
        propertyType: { value: 1, stat: false, msg: "Property type is required" },
        subType: { value: 1, stat: false, msg: "Sub-type is required" },
        condominiumName: "",
        subdivisionName: "",
        buildingName: "",
        unitNoFloorNo: "",
        blockLotUnitFloorNo: "",
        bedroom: "",
        bathroom: "",
        floorArea: "",
        landSize: "",
        forClosure: 0,
        preSelling: 0,
        price: { value: "", stat: false, msg: "Price is required!"},
        monthly: { value: "", stat: false, msg: "Monthly price is required!"},
        yearly: { value: "", stat: false, msg: "Yearly price is required!"},
        showPrice: 0, 
        availableFrom: { value: "", stat: false, msg: "Available date is required!"}, 
        property_seller_information: { contactPerson: { value: "", stat: false, msg: "Contact person is required!" }, email: { value: "", stat: false, msg: "Email is required!" }, mobileNumber: { value: "", stat: false, msg: "Mobile number is required!" } },
    })
    const [otherInfrmtn, setOtherInfrmtn] = useState({
        listing_contact_id: "",
        lastName: { value: "", stat: false, msg: "Last Name is required!" },
        firstName: { value: "", stat: false, msg: "First Name is required!" },
        mobileNumber: { value: "", stat: false, msg: "Please enter a valid mobile number!" },
        email: { value: "", stat: false, msg: "Invalid Email!" },
        province: { value: "", stat: false, msg: "Province is required!" },
        city: { value: "", stat: false, msg: "City is required!" },
        barangay: { value: "", stat: false, msg: "Barangay is required!" },
        streetNumber: "",
        indoorFacilities: { value: [], stat: false, msg: "Select atleast 1 indoor facilities"},
        outdoorFacilities: { value: [], stat: false, msg: "Select atleast 1 outdoor facilities"},
        isAgreedToPay: { value: 0, stat: false, msg: "This agreement is required!" },
        youtubeLink: { value: "", stat: false, msg: "Please enter a proper youtube link!" },
        propertyCoverPhoto: { value: "", stat: false, msg: "Cover photo is required!", objectImg: "", b64Img: "" },
        morePhotos: { value: [], stat: false, msg: "More photos are required!", b64Imgs: [], imgProperties: [] },
        photos: [],
        checkList: [],
        contact_details_for_buyers: { firstName: { value: "", stat: false, msg: "First name is required!" }, lastName: { value: "", stat: false, msg: "Last name is required!" }, email: { value: "", stat: false, msg: "Email is required!" }, mobileNumber: { value: "", stat: false, msg: "Contact number is required!" } }, 
    })
    const dfltMainInfrmtn = {
        listingTitle: { value: "", stat: false, msg: "Listing title is required" },
        description: "",
        ownerType: { value: 1, stat: false, msg: "Owner type is required" },
        offerType: { value: 1, stat: false, msg: "Offer type is required" },
        propertyType: { value: 1, stat: false, msg: "Property type is required" },
        subType: { value: 1, stat: false, msg: "Sub-type is required" },
        condominiumName: "",
        subdivisionName: "",
        buildingName: "",
        unitNoFloorNo: "",
        blockLotUnitFloorNo: "",
        bedroom: "",
        bathroom: "",
        floorArea: "",
        landSize: "",
        forClosure: 0,
        preSelling: 0,
        price: { value: "", stat: false, msg: "Price is required!"},
        monthly: { value: "", stat: false, msg: "Monthly price is required!"},
        yearly: { value: "", stat: false, msg: "Yearly price is required!"},
        showPrice: 0, 
        availableFrom: { value: "", stat: false, msg: "Available date is required!"}, 
        property_seller_information: { contactPerson: { value: "", stat: false, msg: "Contact person is required!" }, email: { value: "", stat: false, msg: "Email is required!" }, mobileNumber: { value: "", stat: false, msg: "Mobile number is required!" } },
    }

    const dfltOtherInfrmtn = {
        listing_contact_id: "",
        lastName: { value: "", stat: false, msg: "Last Name is required!" },
        firstName: { value: "", stat: false, msg: "First Name is required!" },
        mobileNumber: { value: "", stat: false, msg: "Please enter a valid mobile number!" },
        email: { value: "", stat: false, msg: "Invalid Email!" },
        province: { value: "", stat: false, msg: "Province is required!" },
        city: { value: "", stat: false, msg: "City is required!" },
        barangay: { value: "", stat: false, msg: "Barangay is required!" },
        streetNumber: "",
        indoorFacilities: { value: [], stat: false, msg: "Select atleast 1 indoor facilities"},
        outdoorFacilities: { value: [], stat: false, msg: "Select atleast 1 outdoor facilities"},
        isAgreedToPay: { value: 0, stat: false, msg: "This agreement is required!" },
        youtubeLink: { value: "", stat: false, msg: "Please enter a proper youtube link!" },
        propertyCoverPhoto: { value: "", stat: false, msg: "Cover photo is required!", objectImg: "", b64Img: "" },
        morePhotos: { value: [], stat: false, msg: "More photos are required!", b64Imgs: [], imgProperties: [] },
        photos: [],
        checkList: [],
        contact_details_for_buyers: { firstName: { value: "", stat: false, msg: "First name is required!" }, lastName: { value: "", stat: false, msg: "Last name is required!" }, email: { value: "", stat: false, msg: "Email is required!" }, mobileNumber: { value: "", stat: false, msg: "Contact number is required!" } }, 
    }
    // for my property listings
    const [myPrptyLstngs, setMyPrptyLstngs] = useState({
        list: [],
        id: 0,
        modal: false,
        loader: false,
        success: false,
        status: 0,
        type: '',
        listLoader: false,
    })
    const statuses = [
        { id: 1, name: 'For Inquiry' }, 
        { id: 2, name: 'Declined' }, 
        { id: 3, name: 'Approved' }, 
        { id: 4, name: 'Appointment Scheduled' }, 
        { id: 5, name: 'Appointment Completed' },
        { id: 6, name: 'Appointment Cancelled' },
        { id: 7, name: 'Requirements Saved' },
        { id: 8, name: 'Deal Closed' },
    ]
    const statusStyles = {
        'For Inquiry':        { bgcolor: '#e3f2fd', color: '#0d47a1' },
        'Declined':           { bgcolor: '#ffebee', color: '#b71c1c' },
        'Approved':           { bgcolor: '#e8f5e9', color: '#1b5e20' },
        'Appointment Scheduled': { bgcolor: '#fff3e0', color: '#e65100' },
        'Appointment Completed': { bgcolor: '#ede7f6', color: '#4a148c' },
        'Appointment Cancelled': { bgcolor: '#fbe9e7', color: '#bf360c' },
        'Requirements Saved': { bgcolor: '#e3f2fd', color: '#1565c0' },
        'Deal Closed':        { bgcolor: '#d7ccc8', color: '#4e342e' },
        'Unknown Status':     { bgcolor: '#eeeeee', color: '#616161' }
    };
    // list of inquiries in each property
    const [prptyInqrs, setPrptyInqrs] = useState({
        list: [],
        loader: false,
    }) 
    const [inquiryData, setInquiryData] = useState({
        data: [],
        loader: false,
        modal: false,
        sendLoader: false,
        success: false,
        active: 1,
    })
    const [inquiryForm, setInquiryForm] = useState({
        status: { value: 1, stat: false, msg: 'Status is required!' },
        description: { value: '', stat: false, msg: 'Description is required!' },
        reason_for_rejection: { value: '', stat: false, msg: 'Reason is required!' },
    })
    const [appntmntForm, setAppntmntForm] = useState({
        date: { value: '', stat: false, msg: 'Date is required!' },
        time: { value: '', stat: false, msg: 'Time is required!' },
        reason_for_cancelled: { value: '', stat: false, msg: 'Reason is required!' },
    })
    const [fileTypes, setFileTypes] = useState({
        loader: false,
        userType: 1,
        fileType: 0,
        reqs: [],
        sellerAvailReq: [],
        buyerAvailReq: [],
        existing_file_reqs: '',
    });
    const [requirements, setRequirements] = useState({
        avail_reqs: [],
        match_reqs: [],
        modal: false,
        loader: false,
        sendLoader: false,
        sendSuccess: false,
        modalType: '',
        error: false,
    })
    const [newReqName, setNewReqName] = useState({
        name: { value: '', stat: false, msg: 'Name is required!', exist: false, exist_msg: 'Requirement already exist!' },
        addReqModal: false,
        loader: false,
        success: false,
    })

    return {    
        loader: { data: loader, set: setLoader },
        inquiries: { data: inquiries, set: setInquiries },
        agents: { data: agents, set: setAgents },
        rqstdLstng: { data: rqstdLstng, set: setRqstdLstng },
        types: { data: types, set: setTypes },
        dataLocations: { data: dataLocations, set: setDataLocations },
        confirmation: { data: confirmation, set: setConfirmation },
        status: { data: status, set: setStatus },
        mainInfrmtn: { data: mainInfrmtn, set: setMainInfrmtn },
        otherInfrmtn: { data: otherInfrmtn, set: setOtherInfrmtn },
        dfltMainInfrmtn: { data: dfltMainInfrmtn },
        dfltOtherInfrmtn: { data: dfltOtherInfrmtn },
        myPrptyLstngs: { data: myPrptyLstngs, set: setMyPrptyLstngs },
        statuses: { data: statuses },
        statusStyles: { data: statusStyles },
        prptyInqrs: { data: prptyInqrs, set: setPrptyInqrs },
        inquiryData: { data: inquiryData, set: setInquiryData },
        inquiryForm: { data: inquiryForm, set: setInquiryForm },
        appntmntForm: { data: appntmntForm, set: setAppntmntForm },
        fileTypes: { data: fileTypes, set: setFileTypes },
        requirements: { data: requirements, set: setRequirements },
        newReqName: { data: newReqName, set: setNewReqName },
    }
}